import ClearIcon from '@mui/icons-material/Clear';
import { Divider, Grid, IconButton, InputAdornment, TextField } from '@mui/material';

import useAppUtils from '../utils/appUtils';
import clientUtils from '../utils/clientUtils';

interface Iprops {
  tagState: any;
  isEditingDisabled: boolean;
  onSingleTagFieldBlur: (e) => void;
  onMultipleTagFieldBlur: (e) => void;
  onInputChange: (e) => void;
}

const HeaderTitle = ({ columnWidth, title }) => {
  return (
    <Grid item xs={columnWidth} sx={{ paddingTop: '40px', paddingBottom: '10px' }}>
      <h2 style={{ fontWeight: 700, paddingBottom: '10px' }}>{title}</h2>
      <Divider textAlign="left" />
    </Grid>
  );
};

const EndAdornment = ({ onChangeFiledDictionary, fieldName, fieldDictionary }) => {
  return (
    <InputAdornment position="end">
      {!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary[fieldName] && (
        <IconButton
          size="small"
          sx={{ position: 'absolute', top: '5px', right: '0px' }}
          onClick={() => onChangeFiledDictionary(fieldName, false)}
        >
          <i className="fa fa-pencil-square-o" />
        </IconButton>
      )}
      {!clientUtils.isObjectEmpty(fieldDictionary) && fieldDictionary[fieldName] && (
        <IconButton
          size="small"
          sx={{ position: 'absolute', top: '5px', right: '0px' }}
          onClick={() => onChangeFiledDictionary(fieldName, true)}
        >
          <ClearIcon />
        </IconButton>
      )}
    </InputAdornment>
  );
};
const MetadataContent = ({
  tagState,
  isEditingDisabled,
  onSingleTagFieldBlur,
  onMultipleTagFieldBlur,
  onInputChange,
  columnWidth = 12,
  fieldDictionary = {},
  usedFor = '',
  updateFiledDictionary = null,
}) => {
  const { alert } = useAppUtils();
  // const [columnWidth, setColumnWidth] = useState(12);
  // console.log('tagState', tagState);

  const onInputChangeFun = (event) => {
    if (event.target.name === 'european-fsk-rating') {
      const value = event.target.value !== '' ? parseInt(event.target.value) : event.target.value;
      if (value < -1 || value > 18) {
        return;
      }
    }
    onInputChange(event);
  };

  const handleKeyPress = (event) => {
    // console.log('event.which', event.which);
    const isMultiTagField = ['actor', 'producer', 'director', 'genre', 'team-name', 'league-name'].includes(event.target.name);

    const code = event.which ? event.which : event.keyCode;
    if (event.target.name === 'european-fsk-rating' && code > 31 && (code < 48 || code > 57)) {
      event.preventDefault();
    }
    switch (event.key) {
      case ',':
        if (isMultiTagField) {
          setTimeout(() => {
            event.preventDefault();
          }, 0);
        } else {
          event.preventDefault();
          alert('Commas and backslashes not allowed in tag names.', 'warning');
        }
        break;

      case '\\': {
        event.preventDefault();
        alert('Backslashes not allowed in tag names.', 'warning');
        break;
      }
      case 'Tab':
      case 'Enter': {
        event.target.blur();
        break;
      }
      default:
    }
  };

  const onChangeFiledDictionary = (fieldName, clearData = false) => {
    if (updateFiledDictionary) {
      updateFiledDictionary(fieldName, clearData, true);
    }
  };

  return (
    <Grid container spacing={2} className="section-box">
      <HeaderTitle columnWidth={columnWidth} title="Program" />
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Series Name"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.series)}
          placeholder="Type here..."
          name="series"
          value={tagState.series}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="series"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Season Number"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.season)}
          placeholder="Type here..."
          name="season"
          value={tagState.season}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="season"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>

      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Episode Number"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.episode)}
          placeholder="Type here..."
          name="episode"
          value={tagState.episode}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="episode"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Cast"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.actor)}
          placeholder="Type here..."
          name="actor"
          value={tagState.actor}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onMultipleTagFieldBlur}
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="actor"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Producers"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.producer)}
          placeholder="Type here..."
          name="producer"
          value={tagState.producer}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onMultipleTagFieldBlur}
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="producer"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>

      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Directors"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.director)}
          placeholder="Type here..."
          name="director"
          value={tagState.director}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onMultipleTagFieldBlur}
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="director"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Genre"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary.genre)}
          placeholder="Type here..."
          name="genre"
          value={tagState.genre}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onMultipleTagFieldBlur}
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="genre"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Program Type"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['program-type'])}
          placeholder="Type here..."
          name="program-type"
          value={tagState['program-type']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="program-type"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Original Air Date"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['original-air-date'])}
          placeholder="Type here..."
          name="original-air-date"
          value={tagState['original-air-date']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="original-air-date"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <HeaderTitle columnWidth={columnWidth} title="Rating" />
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="MPAA Rating"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['rating-mpaa'])}
          placeholder="Type here..."
          name="rating-mpaa"
          value={tagState['rating-mpaa']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="rating-mpaa"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="BBFC Rating"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['rating-bbfc'])}
          placeholder="Type here..."
          name="rating-bbfc"
          value={tagState['rating-bbfc']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="rating-bbfc"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="US Parental Ratings"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['us-parental-ratings'])}
          placeholder="Type here..."
          name="us-parental-ratings"
          value={tagState['us-parental-ratings']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="us-parental-ratings"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="European FSK Rating "
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['european-fsk-rating'])}
          placeholder="Type here..."
          inputProps={{ pattern: '{0,18}' }}
          name="european-fsk-rating"
          value={tagState['european-fsk-rating']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          helperText="This rating system is structured with value between 0 - 18."
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="european-fsk-rating"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <HeaderTitle columnWidth={columnWidth} title="Sports" />
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Team Names"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['team-name'])}
          placeholder="Type here..."
          name="team-name"
          value={tagState['team-name']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onMultipleTagFieldBlur}
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="team-name"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="League names"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['league-name'])}
          placeholder="Type here..."
          name="league-name"
          value={tagState['league-name']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onMultipleTagFieldBlur}
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="league-name"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <HeaderTitle columnWidth={columnWidth} title="Network" />

      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="Network Value"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['network-value'])}
          placeholder="Type here..."
          name="network-value"
          value={tagState['network-value']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="network-value"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="TMSID Episode"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['tmsid-episode'])}
          placeholder="Type here..."
          name="tmsid-episode"
          value={tagState['tmsid-episode']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="tmsid-episode"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
      <Grid item xs={columnWidth}>
        <TextField
          variant="outlined"
          label="TMSID Series"
          fullWidth
          size="small"
          disabled={isEditingDisabled || (!clientUtils.isObjectEmpty(fieldDictionary) && !fieldDictionary['tmsid-series'])}
          placeholder="Type here..."
          name="tmsid-series"
          value={tagState['tmsid-series']}
          onChange={onInputChangeFun}
          onKeyDown={handleKeyPress}
          onBlur={onSingleTagFieldBlur}
          autoComplete="off"
          InputProps={{
            endAdornment:
              usedFor === 'Scheduled' ? (
                <EndAdornment
                  fieldName="tmsid-series"
                  onChangeFiledDictionary={onChangeFiledDictionary}
                  fieldDictionary={fieldDictionary}
                />
              ) : null,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default MetadataContent;
